import Head from "next/head";

export function StandardMeta({ title = "", description = "", keyword = "", canonical = "" }) {
    return (
        <Head>
            <meta key="standard-title" name="title" content={title} />
            <meta key="standard-description" name="description" content={description} />
            <meta key="standard-keywords" name="keywords" content={keyword} />
            <link key="standard-canonical" rel="canonical" href={canonical} />
        </Head>
    );
}

export function GoogleMeta({ title = "", description = "", image = "" }) {
    return (
        <Head>
            <meta key="google-name" itemProp="name" content={title} />
            <meta key="google-description" itemProp="description" content={description} />
            <meta key="google-image" itemProp="image" content={image} />
        </Head>
    );
}

export function FacebookMeta({ locale = "en_US", type = "", url = "", title = "", description = "", site_name = "", image = "" }) {
    return (
        <Head>
            <meta key="og:locale" property="og:locale" content={locale} />
            <meta key="og:type" property="og:type" content={type} />
            <meta key="og:url" property="og:url" content={url} />
            <meta key="og:title" property="og:title" content={title} />
            <meta key="og:description" property="og:description" content={description} />
            <meta key="og:site_name" property="og:site_name" content={site_name} />
            <meta key="og:image" property="og:image" content={image} />
        </Head>
    );
}

export function TwitterMeta({ card = "summary_large_image", site = "@ugrado_official", url = "", title = "", description = "", image = "" }) {
    return (
        <Head>
            <meta key="twitter:card" property="twitter:card" content={card} />
            <meta key="twitter:site" property="twitter:site" content={site} />
            <meta key="twitter:url" name="twitter:url" content={url} />
            <meta key="twitter:title" property="twitter:title" content={title} />
            <meta key="twitter:description" property="twitter:description" content={description} />
            <meta key="twitter:image" property="twitter:image" content={image} />
        </Head>
    );
}

/**
 * This component compiled and return all meta tag without duplication.
 * 
 * @see {@link StandardMeta}
 * @see {@link GoogleMeta}
 * @see {@link FacebookMeta}
 * @see {@link TwitterMeta}
 * 
 * @param {AllMetaProps} props
 * @param {React.ReactNode} props.children
 * 
 * @returns {JSX.Element}
 */
export function AllMeta({ title = "", description = "", keyword = "", image = "", currentPageUrl = "", locale = "en_US", type = "", twitterHandle = "@ugrado_official", children }) {
    return (
        <>
            <StandardMeta title={title} description={description} keyword={keyword} canonical={currentPageUrl} />
            <GoogleMeta title={title} description={description} image={image} />
            <FacebookMeta locale={locale} type={type} url={currentPageUrl} title={title} description={description} site_name={title} image={image} />
            <TwitterMeta site={twitterHandle} url={currentPageUrl} title={title} description={description} image={image} />
            <Head>{ children }</Head>
        </>
    );
}